import React, { useMemo } from "react";
import { motion } from "framer-motion";
import ProcessOverview from "./test/ProcessOverview";
import TestArea from "./test/TestArea";
import TestStatistics from "./test/TestStatistics";
import { getTestAreas } from "./test/testAreas";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const TestSection = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const testSection = labels.menuPages?.sellCar?.testSection || {};
  const sectionTitle =
    testSection.sectionTitle ?? "100% Transparent Fordonskontroll";
  const sectionDescription =
    testSection.sectionDescription ??
    "Vårt omfattande test säkerställer att din bil värderas korrekt och att köpare får fullständig transparens. Detta ökar förtroendet och maximerar försäljningspriset.";

  const testAreas = useMemo(() => getTestAreas(language), [language]);

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{
            opacity: 0,
            y: 50,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.8,
          }}
          viewport={{
            once: true,
          }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            {sectionTitle}
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            {sectionDescription}
          </p>
        </motion.div>

        <ProcessOverview />

        {/* Brick-like layout - staggered boxes */}
        {testAreas.length >= 4 && (
          <div className="max-w-6xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* First column */}
              <div className="space-y-6">
                <TestArea
                  icon={testAreas[0].icon}
                  title={testAreas[0].title}
                  items={testAreas[0].items}
                  index={0}
                />
                <TestArea
                  icon={testAreas[2].icon}
                  title={testAreas[2].title}
                  items={testAreas[2].items}
                  index={2}
                />
              </div>

              {/* Second column - offset down for brick effect */}
              <div className="space-y-6 lg:mt-12">
                <TestArea
                  icon={testAreas[1].icon}
                  title={testAreas[1].title}
                  items={testAreas[1].items}
                  index={1}
                />
                <TestArea
                  icon={testAreas[3].icon}
                  title={testAreas[3].title}
                  items={testAreas[3].items}
                  index={3}
                />
              </div>
            </div>
          </div>
        )}

        <TestStatistics />
      </div>
    </section>
  );
};
export default TestSection;
